export let skipToMessage = "J$kaOd";
export let readingPane = "sdAwOd";
export default {skipToMessage,readingPane};